var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import Dropzone from 'react-dropzone';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faFileDownload } from '@fortawesome/pro-solid-svg-icons/faFileDownload';
import { faFileUpload } from '@fortawesome/pro-solid-svg-icons/faFileUpload';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { get } from '../utils/funcs';
import Badge from './badge';
import Card from './card';
import Loader from './loader';
import Undraw from './undraw';
import { Header5, Header6 } from './typography';

var hoverCss = function hoverCss(disabled, hasFile) {
  if (!disabled) {
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &.active {\n        cursor: copy;\n      }\n\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        cursor: pointer;\n        ", "\n        outline: 0;\n        & > .file-overlay {\n          opacity: 1;\n        }\n      }\n    "], ["\n      &.active {\n        cursor: copy;\n      }\n\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        cursor: pointer;\n        ", "\n        outline: 0;\n        & > .file-overlay {\n          opacity: 1;\n        }\n      }\n    "])), hasFile ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n              box-shadow: ", ";\n              transition: box-shadow 250ms ease-in-out;\n            "], ["\n              box-shadow: ", ";\n              transition: box-shadow 250ms ease-in-out;\n            "])), function (p) {
      return p.theme.boxShadowLarge;
    }) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              box-shadow: inset 0 0 0.75rem 0.25rem\n                ", ";\n              transition: box-shadow 100ms ease-in-out;\n            "], ["\n              box-shadow: inset 0 0 0.75rem 0.25rem\n                ", ";\n              transition: box-shadow 100ms ease-in-out;\n            "])), function (p) {
      return p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' || p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.primary;
    }));
  } else {
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      cursor: not-allowed;\n    "], ["\n      cursor: not-allowed;\n    "])));
  }
};

var fileCss = function fileCss(disabled, hasFile) {
  return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: ", ";\n  display: flex;\n  flex-shrink: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 1em;\n  min-height: 13rem;\n  max-height: 17rem;\n  min-width: 9rem;\n  max-width: 12rem;\n  padding: 1em;\n  position: relative;\n  ", "\n  ", "\n"], ["\n  align-items: center;\n  border-radius: ", ";\n  display: flex;\n  flex-shrink: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 1em;\n  min-height: 13rem;\n  max-height: 17rem;\n  min-width: 9rem;\n  max-width: 12rem;\n  padding: 1em;\n  position: relative;\n  ", "\n  ", "\n"])), function (p) {
    return p.theme.borderRadius;
  }, hasFile ? css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        box-shadow: ", ";\n        transition: box-shadow 250ms ease-in-out;\n      "], ["\n        box-shadow: ", ";\n        transition: box-shadow 250ms ease-in-out;\n      "])), function (p) {
    return p.theme.boxShadow;
  }) : css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        border: ", " dashed ", ";\n        transition: box-shadow 100ms ease-in-out;\n      "], ["\n        border: ", " dashed ", ";\n        transition: box-shadow 100ms ease-in-out;\n      "])), function (p) {
    return p.theme.borderWidth;
  }, function (p) {
    return p.theme.highContrast;
  }), hoverCss(disabled, hasFile));
};

var FileTitle = styled(Header5)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  text-align: center;\n  width: 100%;\n"], ["\n  text-align: center;\n  width: 100%;\n"])));
var FileName = styled(Header6)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  text-align: center;\n  width: 100%;\n"], ["\n  text-align: center;\n  width: 100%;\n"])));
var UploadZone = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return fileCss(p.disabled, p.hasFile);
});
var FileItem = styled(Card)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return fileCss(p.disabled, p.hasFile);
});
var ActionOverlay = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-shrink: 1;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  &:hover,\n  &:focus {\n    opacity: 1;\n  }\n"], ["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-shrink: 1;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  &:hover,\n  &:focus {\n    opacity: 1;\n  }\n"])), function (p) {
  return p.theme.highContrast;
});
var OverlayBackground = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  height: 100%;\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  height: 100%;\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"])), function (p) {
  return p.theme.level4;
}, function (p) {
  return p.theme.danger;
});
var OverlayIconLayers = styled.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  z-index: 1;\n  .overlay-icon-front {\n    color: ", ";\n  }\n\n  .overlay-icon-back {\n    color: ", ";\n  }\n"], ["\n  z-index: 1;\n  .overlay-icon-front {\n    color: ", ";\n  }\n\n  .overlay-icon-back {\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.highContrast;
}, function (p) {
  return p.theme.lowContrast;
});
var OverlayDeleteFile = styled(FontAwesomeIcon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  position: absolute;\n  top: -0.5em;\n  right: -0.5em;\n\n  &:hover,\n  &:active {\n    color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: -0.5em;\n  right: -0.5em;\n\n  &:hover,\n  &:active {\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.danger;
});
var RequiredHeader6 = styled(Header6)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  color: ", ";\n  margin: 0;\n"], ["\n  color: ", ";\n  margin: 0;\n"])), function (p) {
  return p.theme.white;
}); //type AnyFileType = DocFileType | ImgFileType;

var FileUpload =
/** @class */
function (_super) {
  __extends(FileUpload, _super);

  function FileUpload(props) {
    var _this = _super.call(this, props) || this;

    _this.acceptDocs = ['.doc', '.docx', '.pdf', '.txt'];
    _this.acceptImgs = ['.jpg', '.jpeg', '.png', '.gif', '.tiff']; //accept: AnyFileType[] = [...this.acceptDocs, ...this.acceptImgs];

    _this.emptyState = {
      file: null,
      fileType: null,
      rejected: false,
      failed: false
    };

    _this.onDrop = function (accepted, rejected) {
      var newState = __assign({}, _this.emptyState);

      if (rejected.length > 0) {
        newState.rejected = true;
        newState.file = rejected[0];
      } else if (accepted.length > 0) {
        var file = accepted[0];
        var ext = file.name.match(/\.[0-9a-z]+$/i)[0].toLowerCase();
        newState.file = file;

        if (_this.acceptImgs.includes(ext)) {
          newState.fileType = 'img';
        } else {
          newState.fileType = 'doc';
        }
      }

      _this.setState(__assign(__assign({}, _this.state), newState), function () {
        var _a = _this.props,
            onAddFile = _a.onAddFile,
            onAddFileFailure = _a.onAddFileFailure;

        if (newState.rejected) {
          onAddFileFailure && onAddFileFailure(_this.state.file);

          _this.setState(__assign({}, _this.emptyState));
        } else {
          onAddFile && onAddFile(_this.state.file);
        }
      });
    };

    _this.removeFile = function (e) {
      e.stopPropagation();
      var onRemoveFile = _this.props.onRemoveFile;

      if (onRemoveFile) {
        try {
          onRemoveFile(_this.state);
        } catch (e) {
          _this.setState(__assign(__assign({}, _this.state), {
            failed: true
          }));
        }
      } else {
        _this.setState(__assign({}, _this.emptyState));
      }
    };

    _this.downloadFile = function () {
      var file = _this.state.file;
      var onDownloadFile = _this.props.onDownloadFile;

      if (onDownloadFile) {
        onDownloadFile(_this.state);
      } else if (file instanceof File) {
        var link = document.createElement('a');
        link.download = file.name;
        link.href = window.URL.createObjectURL(file);
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    };

    _this.getActionOverlay = function (action) {
      var file = _this.state.file;
      var allowDelete = _this.props.allowDelete;
      var icon = file ? faFileDownload : faFileUpload;
      return React.createElement(ActionOverlay, {
        className: "file-overlay",
        onClick: action
      }, React.createElement(OverlayBackground, null), file && allowDelete && React.createElement(OverlayDeleteFile, {
        onClick: _this.removeFile,
        icon: faTimesCircle,
        size: "2x",
        fixedWidth: true
      }), React.createElement(OverlayIconLayers, {
        className: "fa-layers fa-7x fa-fw"
      }, React.createElement(FontAwesomeIcon, {
        className: "overlay-icon-back",
        icon: faFile,
        fixedWidth: true
      }), React.createElement(FontAwesomeIcon, {
        className: "overlay-icon-front",
        icon: icon,
        fixedWidth: true
      })));
    };

    _this.getFileItem = function () {
      var _a = _this.props,
          allowDownload = _a.allowDownload,
          disabled = _a.disabled,
          title = _a.title;
      var _b = _this.state,
          file = _b.file,
          fileType = _b.fileType;
      var isDisabled = disabled || !allowDownload;
      var image = fileType === 'img' ? 'photo' : 'document';
      return React.createElement(FileItem, {
        className: "file-item",
        disabled: isDisabled,
        hasFile: !!_this.state.file
      }, React.createElement(FileTitle, null, title), _this.props.isDownloading || _this.props.isUploading ? React.createElement(React.Fragment, null, React.createElement(Loader, {
        variant: _this.props.isUploading ? 'push' : 'pull'
      }), React.createElement(FileName, null, get(file, 'name'))) : React.createElement(React.Fragment, null, React.createElement(Undraw, {
        image: image,
        size: 1 / 4
      }), React.createElement(FileName, null, get(file, 'name')), !isDisabled && _this.getActionOverlay(_this.downloadFile)));
    };

    _this.getUploadZone = function () {
      return React.createElement(Dropzone, {
        accept: _this.props.accept ? _this.props.accept.join(',') : [''],
        disabled: _this.props.disabled || !_this.props.allowUpload,
        onDrop: _this.onDrop,
        multiple: false
      }, function (_a) {
        var getRootProps = _a.getRootProps,
            getInputProps = _a.getInputProps,
            isDragActive = _a.isDragActive;
        var className = "file-item empty" + (isDragActive ? ' active' : '');
        var isDisabled = _this.props.disabled || !_this.props.allowUpload;
        var hasFile = !!_this.state.file;

        var combinedProps = __assign({
          className: className,
          disabled: isDisabled,
          hasFile: hasFile
        }, getRootProps());

        return React.createElement(UploadZone, combinedProps, React.createElement(React.Fragment, null, React.createElement("input", getInputProps()), React.createElement(FileTitle, null, _this.props.title), React.createElement(Undraw, {
          image: "file-add",
          size: 1 / 4
        }), _this.props.requiredUpload ? React.createElement(Badge, {
          brand: "danger"
        }, React.createElement(RequiredHeader6, null, "Upload Required")) : React.createElement(FileName, null, "Upload"), !isDisabled && _this.getActionOverlay()));
      });
    };

    var file = null;

    if (props.file instanceof File) {
      file = props.file;
    } else {
      file = props.fileName ? {
        name: props.fileName
      } : null;
    }

    _this.state = __assign(__assign({}, _this.emptyState), {
      file: file,
      fileType: props.fileType || null
    });
    return _this;
  }

  FileUpload.prototype.render = function () {
    if (this.state.failed) {
      return React.createElement("div", null, "failed");
    } else if (this.state.file) {
      return this.getFileItem();
    } else {
      return this.getUploadZone();
    }
  };

  return FileUpload;
}(React.Component);

export default FileUpload;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;